var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _linearGradient2, _path10, _path11, _circle2, _path12, _linearGradient3, _path13, _linearGradient4, _path14, _linearGradient5, _path15, _linearGradient6, _path16, _linearGradient7, _path17, _linearGradient8, _path18, _linearGradient9, _path19, _g, _path20, _path21, _path22, _path23, _linearGradient10, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 32.686,
    y1: 306.421,
    x2: 399.686,
    y2: 238.421,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.9 136.3c-22.4-56.9-91.2-91-149.6-68.4-66.6 25.8-44.5 131.7-105 153.1-32.7 11.6-81-31.6-114-38.3-60.8-12.2-115.8 30.7-129.4 90.1-13.8 60.6 8.4 141.6 75 158.1 79.3 19.6 120.7-51.7 187.2-72.2 68.3-21 144.3 28.6 200.8-31.8 41.8-44.6 57.1-134.3 35-190.6z",
    opacity: 0.25,
    fill: "url(#contract_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.4 118.3c-2.1-29.2-26.4-52.2-56.1-52.2-31.1 0-56.2 25.2-56.2 56.2 0 19.6 10 36.9 25.3 46.9v96.1c0 3.7 3.9 6.1 7.3 4.5l10.5-5.4V424h-30.5c-5.5 0-10 4.5-10 10v17.1c0 11.5 9.3 20.8 20.8 20.8h210.6-.7c11.2-.3 20.3-9.5 20.3-20.8v-312c0-11.5 9.3-20.8 20.9-20.8H210.4z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M358.3 118.1v52.5h45.6c5.5 0 10-4.5 10-10v-42.5c0-9.2-6-17.1-14.3-19.8-2-.7-4.2-1-6.5-1h-55.5c11.4-.1 20.7 9.3 20.7 20.8z",
    fill: "#8faaff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.3 142.1v52.5h45.6c5.5 0 10-4.5 10-10v-42.5c0-9.2-6-17.1-14.3-19.8-2-.7-4.2-1-6.5-1h-55.5c11.4-.1 20.7 9.3 20.7 20.8z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M358.3 118.1v52.5h26.9v-52.5c0-9.2 6-17.1 14.3-19.8-2-.7-4.2-1-6.5-1h-55.5c11.5-.1 20.8 9.3 20.8 20.8z",
    fill: "#6583fe"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.6 97.3c-11.5 0-20.9 9.3-20.9 20.8v312c0 11.5-9.3 20.8-20.8 20.8H162.2V118.1c0-11.5 9.3-20.8 20.8-20.8h210.6z",
    fill: "#d2deff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.1 304.1h-86.9c-2.8 0-5 2.2-5 5v140.4h96.9V309.1c0-2.7-2.2-5-5-5z",
    opacity: 0.25,
    fill: "#0575e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M372.7 226v77.9c-1.5.2-3 .3-4.6.3-21.7 0-39.3-17.6-39.3-39.3 0-21.7 17.6-39.2 39.3-39.2 1.6 0 3.1.1 4.6.3zM231.6 117.4c0 19.6-10 36.9-25.3 46.9v96.1c0 3.7-3.9 6.1-7.3 4.5l-23.7-12.1-13.2 6.7V118.1c0-11.5 9.3-20.8 20.8-20.8h44.9c2.5 6.2 3.8 13 3.8 20.1z",
    fill: "#b7c5ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M353.1 450.9H142.5c-11.5 0-20.8-9.3-20.8-20.8V413c0-5.5 4.5-10 10-10h190.6c5.5 0 10 4.5 10 10v17.1c0 11.5 9.3 20.8 20.8 20.8z",
    fill: "#8faaff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 368.1,
    cy: 251.3,
    r: 39.2,
    fill: "#ffaf10"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 85.805,
    y1: 187.798,
    x2: 289.592,
    y2: 187.798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.3 126.2v118.1c0 3.7-3.9 6.1-7.3 4.5l-23.7-12.1-23.7 12.1c-3.3 1.7-7.3-.7-7.3-4.5V126.2h62z",
    fill: "url(#contract_svg__b)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.3 126.2v35.9c-9.3 4.8-19.8 7.4-31 7.4-11.1 0-21.7-2.7-31-7.4v-35.9h62z",
    fill: "#94b5dd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.4,
    cy: 101.3,
    r: 56.2,
    fill: "#ffd18d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.6 194.5h88.1c3.3 0 6-2.7 6-6V157c0-3.3-2.7-6-6-6h-88.1c-3.3 0-6 2.7-6 6v31.5c.1 3.3 2.7 6 6 6z",
    opacity: 0.25,
    fill: "#0575e6"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 230.066,
    y1: 151.083,
    x2: 256.773,
    y2: 151.083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M251.8 156.1h-16.7c-2.8 0-5-2.2-5-5s2.2-5 5-5h16.7c2.8 0 5 2.2 5 5s-2.3 5-5 5z",
    fill: "url(#contract_svg__c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 230.065,
    y1: 182.309,
    x2: 291.875,
    y2: 182.309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M286.9 187.3h-51.8c-2.8 0-5-2.2-5-5s2.2-5 5-5h51.8c2.8 0 5 2.2 5 5s-2.3 5-5 5z",
    fill: "url(#contract_svg__d)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 230.065,
    y1: 199.193,
    x2: 316.585,
    y2: 199.193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M311.6 204.2h-76.5c-2.8 0-5-2.2-5-5s2.2-5 5-5h76.5c2.8 0 5 2.2 5 5s-2.3 5-5 5z",
    fill: "url(#contract_svg__e)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 201.621,
    y1: 276.28,
    x2: 276.375,
    y2: 276.28
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M271.4 281.3h-64.8c-2.8 0-5-2.2-5-5s2.2-5 5-5h64.8c2.8 0 5 2.2 5 5s-2.3 5-5 5z",
    fill: "url(#contract_svg__f)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 201.621,
    y1: 304.951,
    x2: 338.858,
    y2: 304.951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M333.9 310H206.6c-2.8 0-5-2.2-5-5s2.2-5 5-5h127.2c2.8 0 5 2.2 5 5s-2.2 5-4.9 5z",
    fill: "url(#contract_svg__g)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 201.621,
    y1: 323.971,
    x2: 338.858,
    y2: 323.971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M333.9 329H206.6c-2.8 0-5-2.2-5-5s2.2-5 5-5h127.2c2.8 0 5 2.2 5 5s-2.2 5-4.9 5z",
    fill: "url(#contract_svg__h)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: 201.621,
    y1: 342.991,
    x2: 338.858,
    y2: 342.991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M333.9 348H206.6c-2.8 0-5-2.2-5-5s2.2-5 5-5h127.2c2.8 0 5 2.2 5 5s-2.2 5-4.9 5z",
    fill: "url(#contract_svg__i)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0575e6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237.2,
    cy: 226.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-80.781 254.11 226.573)",
    cx: 254.1,
    cy: 226.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 226.6,
    r: 5.6
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175.4 201.7c-2.8 0-5-2.2-5-5v-11.5c0-2.8 2.2-5 5-5s5 2.2 5 5v11.5c0 2.8-2.3 5-5 5z",
    fill: "#ffaf10"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M393.7 92.3H343c-2.8 0-5 2.2-5 5s2.2 5 5 5h30.1c-3.4 4.4-5.4 9.9-5.4 15.8v89c-24.2.2-43.8 20-43.8 44.2s19.6 44 43.8 44.2V430c0 8.5-6.8 15.5-15.2 15.8-8.4-.3-15.2-7.3-15.2-15.8v-17c0-8.3-6.7-15-15-15H167.2V246.5l8.2-4.2 21.4 10.9c1.4.7 3 1.1 4.5 1.1 1.8 0 3.6-.5 5.2-1.5 3-1.8 4.8-5 4.8-8.5v-93.5c15.1-11 24.9-28.6 25.2-48.6H315c2.8 0 5-2.2 5-5s-2.2-5-5-5h-79C231.6 62.7 206.1 40 175.4 40c-33.8 0-61.2 27.5-61.2 61.2 0 20.3 10 38.4 25.3 49.5v28.9c0 2.8 2.2 5 5 5s5-2.2 5-5v-22.9c7.9 3.7 16.7 5.8 26 5.8s18.1-2.1 26-5.8v87.6l-23.7-12.1c-1.4-.7-3.1-.7-4.5 0l-23.7 12.1v-36.5c0-2.8-2.2-5-5-5s-5 2.2-5 5v36.5c0 3.5 1.8 6.7 4.8 8.5 3 1.8 6.6 2 9.8.4l3.2-1.7V398h-25.5c-8.3 0-15 6.7-15 15v17.1c0 14.2 11.6 25.8 25.8 25.8h210.6c.3 0 .7 0 1-.1 13.2-1.1 23.6-12.2 23.6-25.7V294.5c19.8-4.4 34.7-22.1 34.7-43.2s-14.9-38.8-34.7-43.2v-32.5H404c8.3 0 15-6.7 15-15v-42.5c-.1-14-11.3-25.5-25.3-25.8zm-269.6 9c0-28.3 23-51.2 51.2-51.2s51.2 23 51.2 51.2-23 51.2-51.2 51.2c-28.2.1-51.2-22.9-51.2-51.2zm196.7 344.6H142.6c-8.7 0-15.8-7.1-15.8-15.8V413c0-2.8 2.2-5 5-5h190.6c2.8 0 5 2.2 5 5v17.1c0 6 2 11.5 5.4 15.8h-12zm81.6-194.6c0 18.9-15.4 34.2-34.2 34.2S334 270.1 334 251.3s15.4-34.2 34.2-34.2 34.2 15.4 34.2 34.2zm6.5-90.7c0 2.8-2.2 5-5 5h-26.1v-47.5c0-8.6 7-15.7 15.6-15.8 8.6.1 15.6 7.2 15.6 15.8v42.5z",
    fill: "#0046c1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M175.4 140c-21.3 0-38.7-17.4-38.7-38.7s17.4-38.7 38.7-38.7 38.7 17.4 38.7 38.7-17.4 38.7-38.7 38.7zm0-67.4c-15.8 0-28.7 12.9-28.7 28.7s12.9 28.7 28.7 28.7c15.8 0 28.7-12.9 28.7-28.7s-12.9-28.7-28.7-28.7z",
    fill: "#ffaf10"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M177.1 120.1c-2.8 0-5-2.2-5-5v-22h-.4c-2.8 0-5-2.2-5-5s2.2-5 5-5h5.4c2.8 0 5 2.2 5 5v27.1c0 2.7-2.2 4.9-5 4.9z",
    fill: "#fff"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: 320.036,
    y1: 156.889,
    x2: 353.262,
    y2: 156.889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M353.3 151.1c0-9.2-7.5-16.6-16.6-16.6s-16.6 7.5-16.6 16.6c0 4.5 1.8 8.6 4.8 11.6-2.9 3-4.8 7.1-4.8 11.6 0 2.8 2.2 5 5 5s5-2.2 5-5c0-3.6 3-6.6 6.6-6.6s6.6 3 6.6 6.6c0 2.8 2.2 5 5 5s5-2.2 5-5c0-4.5-1.8-8.6-4.8-11.6 2.9-3 4.8-7.1 4.8-11.6zm-16.7-6.6c3.6 0 6.6 3 6.6 6.6s-3 6.6-6.6 6.6-6.6-3-6.6-6.6 3-6.6 6.6-6.6z",
    fill: "url(#contract_svg__j)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M445.4 252.1h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5zM102.4 200.5h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.3-5-5-5z",
    fill: "#8399fe"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M413.2 431.6H410v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.3-5-5.1-5z",
    fill: "#01eca5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8 174.2c-1.5 0-2.9-.2-4.4-.7-3.7-1.2-6.8-3.7-8.6-7.1-1.8-3.5-2.2-7.4-1-11.1 1.2-3.7 3.7-6.8 7.2-8.6 3.5-1.8 7.4-2.2 11.1-1 7.7 2.4 12 10.6 9.6 18.3-1.2 3.7-3.7 6.8-7.2 8.6-2.1 1.1-4.4 1.6-6.7 1.6zm0-19.2c-.7 0-1.5.2-2.1.5-1.1.6-1.9 1.5-2.3 2.7-.4 1.2-.3 2.4.3 3.5s1.5 1.9 2.7 2.3c1.2.4 2.4.3 3.5-.3s1.9-1.5 2.3-2.7c.8-2.4-.6-5-3-5.8-.5-.1-1-.2-1.4-.2z",
    fill: "#ff7eb8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M293.9 83.2c-1.5 0-2.9-.2-4.4-.7-3.7-1.2-6.8-3.7-8.6-7.2-1.8-3.5-2.2-7.4-1-11.1 2.4-7.7 10.6-12 18.3-9.6 7.7 2.4 12 10.6 9.6 18.3-1.2 3.7-3.7 6.8-7.1 8.6-2.1 1.2-4.5 1.7-6.8 1.7zm0-19.2c-2 0-3.8 1.3-4.4 3.2-.4 1.2-.3 2.4.3 3.5s1.5 1.9 2.7 2.3c2.4.8 5-.6 5.8-3 .8-2.4-.6-5-3-5.8-.5-.1-1-.2-1.4-.2z",
    fill: "#01eca5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M368.1 267.6c-1.3 0-2.6-.5-3.5-1.5l-11.4-11.4c-2-2-2-5.1 0-7.1s5.1-2 7.1 0l7.9 7.9 39.9-39.9c2-2 5.1-2 7.1 0s2 5.1 0 7.1l-43.5 43.5c-1 .9-2.2 1.4-3.6 1.4z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.28dd2ff0c0a06fd667845b099ad3943e.svg";
export { ForwardRef as ReactComponent };